import React from 'react';
import classnames from 'classnames';

import { config } from 'utils/config';
import { Link } from 'components/link/Link';
import { Error } from 'components/error/Error';
import { Background } from 'components/background/Background';
import { LOCAL_STORAGE_KEY_VERTICAL } from 'components/devtools/Devtools';
import GridOverlay from 'components/devtools/GridOverlay';

import s from './Layout.module.scss';

type Props = {
  current?: string;
  sections: any[];
};

export const Layout = ({ current, sections }: Props) => {
  const [visible, setVisiblity] = React.useState(!current);
  const [timer, setTimer] = React.useState<any>();
  const [showGrid, setGridVisiblity] = React.useState(false);

  const slices = sections.filter((x) => x.type !== 'element');
  const elements = sections.filter((x) => x.type === 'element');
  const slice = sections.find((x) => x.link === current);
  const [background, setBackground] = React.useState<any>('white');

  if (current && !slice) {
    return <Error title="Whoops!" statusCode={404} />;
  }

  const onEnter = () => {
    clearTimeout(timer);

    setVisiblity(true);
  };

  const onLeave = () => {
    if (!current) {
      return;
    }

    setTimer(setTimeout(() => setVisiblity(false), 500));
  };

  React.useEffect(() => {
    setGridVisiblity(localStorage && localStorage.getItem(LOCAL_STORAGE_KEY_VERTICAL) === '1');
  }, []);

  return (
    <div className={s.layout} id="pageLayout">
      <div
        className={classnames(s.layout__side, { [s.visible]: visible })}
        onMouseEnter={onEnter}
        onMouseLeave={onLeave}
      >
        <div className={s.layout__sticky}>
          <h1 className={s.layout__title}>Alvotech</h1>

          {/* <div className={s.layout__option}>
            <label htmlFor="elementsTheme">Theme</label>
            <select
              id="elementsTheme"
              defaultValue={config.theme}
              onChange={(e) => {
                const el = window.document.querySelector('html');
                if (el) {
                  el.className = e.target.value;
                }
              }}
            >
              <option value="alvogen">Alvogen</option>
              <option value="alvotech">Alvotech</option>
              <option value="adalvo">Adalvo</option>
              <option value="almatica">Almatica</option>
              <option value="almaject">Almaject</option>
            </select>
          </div> */}

          <div className={s.layout__option}>
            <label htmlFor="elementsBackground">Background</label>
            <select
              id="elementsBackground"
              onChange={(e) => {
                setBackground(e.target.value as any);
              }}
            >
              <option value="white">White</option>
              <option value="dark">Dark</option>
              <option value="brand">Brand</option>
            </select>
          </div>

          <div className={s.layout__option}>
            <label htmlFor="elementsGrid">Show grid</label>
            <input
              id="elementsGrid"
              type="checkbox"
              checked={showGrid}
              onChange={(e) => {
                setGridVisiblity(e.target.checked);
                localStorage.setItem(LOCAL_STORAGE_KEY_VERTICAL, e.target.checked ? '1' : '0');
              }}
            />
          </div>

          <h2 className={s.layout__subtitle}>Slices</h2>
          <ul className={s.layout__list}>
            {slices.map(({ link, name, description, Component }, i) => (
              <li key={i}>
                <Link
                  className={classnames(s.item, {
                    [s.isActive]: current === link,
                    [s.isDisabled]: Component === undefined,
                  })}
                  href={`/elements/${link}`}
                  transition={false}
                >
                  <div className={s.item__title}>{name}</div>
                  <div className={s.item__description}>{description}</div>
                </Link>
              </li>
            ))}
          </ul>
          <h2 className={s.layout__subtitle}>Elements</h2>
          <ul className={s.layout__list}>
            {elements.map(({ link, name, description, Component }, i) => (
              <li key={i}>
                <Link
                  className={classnames(s.item, {
                    [s.isActive]: current === link,
                    [s.isDisabled]: Component === undefined,
                  })}
                  href={`/elements/${link}`}
                  transition={false}
                >
                  <div className={s.item__title}>{name}</div>
                  <div className={s.item__description}>{description}</div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className={s.layout__content}>
        <Background currentBackground={background}>
          {slice && slice.Component && <slice.Component {...slice.componentProps} />}
        </Background>

        {showGrid && <GridOverlay />}
      </div>
    </div>
  );
};
